import { forwardRef } from 'react';
import { TextField } from '@mui/material';

import BaseFieldContainer from '../common/baseFieldContainer';
import { mergeSx, mergeSxWithOutlinedBorder } from '../utils/general';
import { FORTA_BLACK } from '../../../utils/colors';

import type { FInputProps } from './types';

const FInput = forwardRef<HTMLDivElement, FInputProps>(function FInput(props, ref) {
  const {
    variant = 'outlined',
    size = 'small',
    sx,
    required,
    showRequiredIndicator,
    disabled,
    InputLabelProps,
    helperText,
    fullWidth,
    ...rest
  } = props;

  const inputLabelProps = {
    ...InputLabelProps,
    required: required && !disabled ? false : undefined,
    shrink: true,
    sx: mergeSx({ color: FORTA_BLACK }, InputLabelProps?.sx),
  };

  return (
    <BaseFieldContainer
      required={required}
      showRequiredIndicator={showRequiredIndicator}
      disabled={disabled}
      helperText={helperText}
      error={rest.error ?? false}
      fullWidth={fullWidth}
    >
      <TextField
        ref={ref}
        variant={variant}
        size={size}
        required={required}
        disabled={disabled}
        InputLabelProps={inputLabelProps}
        helperText={helperText}
        fullWidth={fullWidth}
        sx={mergeSxWithOutlinedBorder(sx)}
        {...rest}
      />
    </BaseFieldContainer>
  );
});

export default FInput;
